<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';
import lockIcon from "!!raw-loader!../../images/lock.svg";
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin],
  data() {
    return {
      lockIcon: lockIcon
    };
  },
  mounted() { },
  methods: {
    isAuthorized(item) {
      return !item.keyword || this.userEditions.find(edition => edition[item.keyword])
    },
    linkText(item) {
      if (!item.keyword) return "Scopri"
      else {
        return this.isAuthorized(item) ? "Scopri" : "Acquista";
      }
    },
    getItemUrl(item) {
      return get(item, ["url", "url"], "javascript:void(0)");
    },
  },
  computed: {
    userEditions() {
      return get(this, ["pageModel","user","contents"], [])
        .filter(content_name => Object.keys(this.content.edition_name_to_content).includes(content_name))
        .map(content_name => this.content.edition_name_to_content[content_name]);
    }
  }
};
</script>

<template>
  <div 
    class="container"
    :class="contentType" 
    v-easyadmin="easyadminId"
    v-if="isContentVisibleToUser()"
    stripe-vbl-premium-links-component
  >
    <div class="row">
      <div class="col-12 px-sm-0">
        <h3 class="text-center my-5" v-if="content.title">{{content.title}}</h3>
        <div class="grid pb-5">
          <div class="item ar-1by1 position-relative" v-for="(item,index) in content.items" :key="index" tile-component>
            <component
              :href="getItemUrl(item)"
              :is="item.url ? 'a' : 'div'"
              :data-keyword="item.keyword"
              :target="getTarget(item.url)"
              :style="{'background-image': getContentResponsiveImageURL('thumbnail', item)}"
              class="position-absolute-center bg-cover-center tile p-4 d-flex flex-column justify-content-between tile-shadow deco-none"
            > 
              <div>
                <component
                  v-if="item.title"
                  class="text-white mb-2"
                  :is="item.title_tag || 'h4'"
                  :class="item.title_class || 'h4 font-weight-bold'"
                  v-html="item.title"/>
                <div v-if="item.description" class="text-white" v-html="item.description"></div>
              </div>
              <div class="d-flex align-items-center justify-content-between text-white">
                <span class="cursor-pointer link-label" v-if="item.url">
                  {{linkText(item)}}
                  <i class="far fa-chevron-right ml-2"></i>
                </span>
                <span class="d-flex align-items-center p-3 lock-icon bg-white text-primary" v-if="!isAuthorized(item)" v-html="lockIcon">
                </span>
              </div>
            </component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[stripe-vbl-premium-links-component] {
  .grid {
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-flow: row dense;
    grid-auto-rows: 1fr;
    grid-gap: 1.5rem;
    display: grid;

    .item {
      grid-row: span 1;
      grid-column: span 1;

      .tile {
        border-radius: 6px;
      }
    }

    @include media-breakpoint-down(sm) {
      grid-template-columns: 1fr;
    }
  }
}
</style>
